<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-video-camera"></i> 实时摄像
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="title">1号位<span class="detail">查看详情</span></div>
                    <img class="image" src="../../assets/img/dd1.png"></img>
                </el-col>
                <el-col :span="8"> 
                    <div class="title">2号位<span class="detail">查看详情</span></div>
                    <img class="image"  src="../../assets/img/dd2.png"></img>
                    </el-col>
                <el-col :span="8">
                     <div class="title">3号位<span class="detail">查看详情</span></div>
                    <img class="image"  src="../../assets/img/dd3.png"></img>
                    </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                     <div class="title">4号位<span class="detail">查看详情</span></div>
                    <img class="image"  src="../../assets/img/dd4.png"></img>
                    </el-col>
                <el-col :span="8"> 
                    <div class="title">5号位<span class="detail">查看详情</span></div>
                    <img class="image"  src="../../assets/img/dd5.png"></img>
                    </el-col>
                <el-col :span="8"> 
                    <div class="title">6号位<span class="detail">查看详情</span></div>
                    <img class="image"  src="../../assets/img/dd6.png"></img>
                    </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.title{
    font-size: .5rem;
    padding: 10px 0;
}
.image{
    width: 100%;

}
.detail{
    font-size: .3rem;
    color: cornflowerblue;
    margin-left: 20px;
}
</style>>